export function attrToBoolean(value: any) {
  return value === '' || !!value;
}